import { render } from "./facts-list.vue?vue&type=template&id=0ab251c7"
import script from "./facts-list.vue?vue&type=script&lang=js"
export * from "./facts-list.vue?vue&type=script&lang=js"

import exportComponent from "C:\\Users\\yrabie\\Documents\\Projects\\Awsat Admin\\node_modules\\vue-loader-v16\\dist\\exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render]])

export default __exports__